["afk/leaving game", "abusive chat", "cheating", "gamethrowing", "stalling", "botting", "other"]
